module.exports = __webpack_public_path__ + "static/img/homeimg01.cf00dbaf.png";